(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tick(el) {
    var until = el.getAttribute('data-until');
    var end;
    if (until && /^\d+$/.test(until)) { end = parseInt(until, 10); }
    else { var d = new Date(); d.setHours(24, 0, 0, 0); end = d.getTime(); }
    var left = Math.max(0, end - Date.now());
    var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), s = Math.floor(left % 60000 / 1000);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var a = el.querySelector('[data-cd-h]'), b = el.querySelector('[data-cd-m]'), c = el.querySelector('[data-cd-s]');
    if (a) a.textContent = pad(h);
    if (b) b.textContent = pad(m);
    if (c) c.textContent = pad(s);
  }
  function publishHeight() {
    var bar = document.querySelector('[data-announcement][data-sticky]');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--refann-h', h + 'px');
  }
  function init(root) {
    publishHeight();
    if (!window.__refannResize) {
      window.__refannResize = true;
      window.addEventListener('resize', publishHeight, { passive: true });
    }
    root.querySelectorAll('.refann__timer').forEach(function (el) {
      tick(el);
      if (el.dataset.started) return;
      el.dataset.started = '1';
      setInterval(function () { tick(el); }, 1000);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-cart-drawer"]) return;
  try {
    
(function () {
  var root, labels = {}, productCache = {};

  function money(cents) {
    // les doubles accolades seraient interpretees par Liquid : on les assemble
    var f = labels.moneyFormat || ('{' + '{amount_with_comma_separator}' + '} €');
    var v = (cents / 100);
    var withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var withDot = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(v).toString())
            .replace(/\{\{\s*amount\s*\}\}/g, withDot)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(v).toString())
            .replace(/<[^>]*>/g, '');
  }

  function open() { if (!root) return; root.hidden = false; requestAnimationFrame(function () { root.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; }
  function close() { if (!root) return; root.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { root.hidden = true; }, 300); }

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function lineMarkup(item, index) {
    var saved = item.original_line_price - item.final_line_price;
    var isFree = item.final_line_price === 0;
    var el = document.createElement('div');
    el.className = 'refcart__line' + (isFree ? ' refcart__line--gift' : '');
    if (isFree) el.setAttribute('data-free', '1');
    el.setAttribute('data-line', index + 1);
    el.setAttribute('data-key', item.key);
    var img = item.image ? '<img class="refcart__line-img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="80" height="80">' : '<span class="refcart__line-img"></span>';
    var side = isFree
      ? '<span class="refcart__line-compare" data-compare="' + item.handle + '"></span>' +
        '<span class="refcart__line-free">' + (labels.free || 'GRATUIT') + '</span>' +
        '<span class="refcart__badge refcart__badge--free">' + (labels.savedPercent || '') + ' 100%</span>'
      : '<span class="refcart__line-price">' + money(item.final_line_price) + '</span>' +
        (saved > 0 ? '<span class="refcart__badge">' + (labels.saved || '') + ' ' + money(saved) + '</span>' : '');
    el.innerHTML =
      img +
      '<div class="refcart__line-body">' +
        '<span class="refcart__line-title">' + item.product_title + '</span>' +
        '<div class="refcart__line-variants" data-variants data-handle="' + item.handle + '" data-variant="' + item.variant_id + '"></div>' +
        '<div class="refcart__qty">' +
          '<button type="button" data-qty="-1" aria-label="-">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          (isFree ? '' : '<button type="button" data-qty="1" aria-label="+">+</button>') +
        '</div>' +
      '</div>' +
      '<div class="refcart__line-side">' + side +
        '<button type="button" class="refcart__remove" data-remove aria-label="' + (labels.remove || 'Retirer') + '">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6">' +
          '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
        '</button>' +
      '</div>';
    return el;
  }

  function fillVariants(el, cart) {
    el.querySelectorAll('[data-variants]').forEach(function (box) {
      var handle = box.getAttribute('data-handle');
      getProduct(handle).then(function (p) {
        if (!p) return;
        var line = box.closest('.refcart__line');
        var cmp = line && line.querySelector('[data-compare]');
        if (cmp) {
          var v0 = p.variants[0];
          if (v0 && v0.compare_at_price) cmp.textContent = money(v0.compare_at_price);
        }
        if (p.variants.length < 2) return;
        var current = box.getAttribute('data-variant');
        var name = (p.options[0] && (p.options[0].name || p.options[0])) || '';
        // le choix d'univers se fait sur la fiche produit : ici on affiche, on ne modifie pas.
        // un menu ici rouvrait le bug de gonflement du panier (quantite relue sur un DOM re-rendu).
        var cur = p.variants.filter(function (v) { return String(v.id) === current; })[0];
        box.innerHTML = '<span class="refcart__line-variant"><span>' + name + '</span>' +
          '<span class="refcart__line-variant-value">' + ((cur && cur.title) || '') + '</span></span>';
      });
    });
  }

  function render(cart) {
    if (!root) return;
    // /cart/change.js et /cart/add.js renvoient un objet d'erreur sans `items`
    // quand la requete echoue : sans cette garde, le tiroir se vidait.
    if (!cart || !Array.isArray(cart.items)) { refresh(); return; }
    var lines = root.querySelector('[data-cart-lines]');
    var empty = root.querySelector('[data-cart-empty]');
    lines.innerHTML = '';
    // la source niche le cadeau sous sa ligne parente : les lignes offertes passent en dernier
    var ordered = cart.items.slice().sort(function (a, b) {
      return (a.final_line_price === 0 ? 1 : 0) - (b.final_line_price === 0 ? 1 : 0);
    });
    // une ligne qui plante ne doit pas emporter tout le rendu avec elle
    ordered.forEach(function (it, i) {
      try { lines.appendChild(lineMarkup(it, i)); } catch (e) { /* ligne ignoree */ }
    });
    fillVariants(lines, cart);
    empty.hidden = cart.items.length > 0;

    var disc = root.querySelector('[data-cart-discounts]');
    var apps = cart.cart_level_discount_applications || [];
    var lineSaving = cart.items.reduce(function (a, i) { return a + (i.original_line_price - i.final_line_price); }, 0);
    var names = apps.map(function (a) { return a.title; });
    cart.items.forEach(function (i) { (i.discounts || []).forEach(function (d) { if (names.indexOf(d.title) < 0) names.push(d.title); }); });
    if (lineSaving > 0 || apps.length) {
      disc.hidden = false;
      // total_discount couvre deja les remises de ligne : ne pas les additionner
      var total = cart.total_discount || lineSaving;
      disc.innerHTML = '<span>' + (labels.discounts || '') + ' <span class="refcart__discount-badge">' +
        names.join(', ') + '</span></span><span>-' + money(total) + '</span>';
    } else { disc.hidden = true; disc.innerHTML = ''; }

    root.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    root.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    var bubble = document.querySelector('.refhd__count');
    if (bubble) bubble.textContent = cart.item_count;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; render(c); return c; })
      .catch(function () { return null; });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .catch(function () { return null; })
      .then(function () { return refresh(); })
      .then(function () { open(); });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .catch(function () { return null; })
      .then(function () { return refresh(); });
  }

  var lastCart = null;
  function giftAlreadyInCart(variantId) {
    if (!lastCart || !Array.isArray(lastCart.items)) return false;
    return lastCart.items.some(function (i) { return String(i.variant_id) === String(variantId); });
  }

  var wired = false;   // garde anti double-init : sans elle, chaque ajout au panier comptait double
  function init() {
    root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    if (wired) { refresh(); return; }   // deja cable : on se contente de rafraichir
    wired = true;
    var cfg = document.querySelector('[data-cart-labels]');
    if (cfg) { try { labels = JSON.parse(cfg.textContent); } catch (e) { labels = {}; } }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      var up = e.target.closest('[data-upsell-add]');
      if (up) { addItems([{ id: Number(up.getAttribute('data-upsell-add')), quantity: 1 }]); return; }
      var line = e.target.closest('.refcart__line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var idx = Number(line.getAttribute('data-line'));
      var q = e.target.closest('[data-qty]');
      if (q) {
        var cur = Number(line.querySelector('.refcart__qty span').textContent) || 1;
        var next = Math.max(0, cur + Number(q.getAttribute('data-qty')));
        // un cadeau reste offert a un seul exemplaire
        if (line.hasAttribute('data-free') && next > 1) return;
        change(key, next);
        return;
      }
      if (e.target.closest('[data-remove]')) { change(key, 0); }
    });

    // handler de changement de variante retire : le panier n'est plus modifiable en variante.

    var prev = root.querySelector('.refcart__arrow--prev');
    var next = root.querySelector('.refcart__arrow--next');
    var list = root.querySelector('[data-cart-carousel]');
    if (prev && next && list) {
      prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth / 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth / 2, behavior: 'smooth' }); });
    }

    // l'ajout au panier ouvre le tiroir au lieu de recharger la page
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') < 0) return;
      e.preventDefault();
      var fd = new FormData(form);
      var items = [];
      var picked = form.querySelector('.refpm__offer.is-selected') || form.ownerDocument.querySelector('.refpm__offer.is-selected');
      var scope = picked || form;
      var multi = scope.querySelectorAll('[data-offer-variant]');
      if (multi.length) {
        multi.forEach(function (sel) { items.push({ id: Number(sel.value), quantity: 1 }); });
      } else {
        items.push({ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) });
      }
      var gift = form.querySelector('[data-gift-input]');
      if (gift && gift.value && !giftAlreadyInCart(gift.value)) {
        items.push({ id: Number(gift.value), quantity: 1 });
      }
      addItems(items);
    }, true);

    // les liens vers le panier ouvrent le tiroir
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      refresh().then(open);
    });

    refresh();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-cart-drawer]')) init(); });
  if (document.readyState !== 'loading') init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('.refhd').forEach(function (hd) {
      var burger = hd.querySelector('.refhd__burger');
      var drawer = hd.querySelector('.refhd__drawer');
      if (!burger || !drawer) return;
      void 0;
      hd.querySelectorAll('.reflocal__button').forEach(function (btn) {
        var pop = btn.nextElementSibling;
        if (!pop) return;
        btn.addEventListener('click', function () {
          var open = pop.hasAttribute('hidden');
          if (open) { pop.removeAttribute('hidden'); } else { pop.setAttribute('hidden', ''); }
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
      var closeBtn = hd.querySelector('.refhd__drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function () {
        drawer.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      });
      burger.addEventListener('click', function () {
        var open = drawer.hasAttribute('hidden');
        if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-product-main"] && !Shopify.designMode) return;
  try {
    
class RefProductGallery extends HTMLElement {}
(function () {
  function init(root) {
    root.querySelectorAll('.refpm').forEach(function (sec) {
      if (sec.getAttribute('data-refpm-ready')) return;   // garde anti double-init
      sec.setAttribute('data-refpm-ready', '1');
      var list = sec.querySelector('.refpm__media-list');
      var thumbs = [].slice.call(sec.querySelectorAll('.refpm__thumb'));
      var slides = [].slice.call(sec.querySelectorAll('.refpm__media'));
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (!slides[i]) return;
          list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: 'smooth' });
          thumbs.forEach(function (x) { x.classList.remove('is-selected'); });
          t.classList.add('is-selected');
        });
      });
      if (list) {
        list.addEventListener('scroll', function () {
          var i = Math.round(list.scrollLeft / (list.clientWidth || 1));
          thumbs.forEach(function (x, j) { x.classList.toggle('is-selected', j === i); });
        }, { passive: true });
      }

      // offres : etat selectionne + quantite envoyee au panier
      var qty = sec.querySelector('[data-quantity-input]');
      var offers = [].slice.call(sec.querySelectorAll('[data-offer]'));
      var giftInput = sec.querySelector('[data-gift-input]');
      function sync() {
        offers.forEach(function (o) {
          var input = o.querySelector('.refpm__offer-input');
          var on = input && input.checked;
          o.classList.toggle('is-selected', !!on);
          if (on && qty) qty.value = o.getAttribute('data-quantity') || '1';
          if (on && giftInput) giftInput.value = o.getAttribute('data-gift-variant') || '';
        });
      }
      offers.forEach(function (o) {
        var input = o.querySelector('.refpm__offer-input');
        if (input) input.addEventListener('change', sync);
      });
      sync();

      // menu de variante maison : pastille + nom, valeur portee par un champ cache
      sec.querySelectorAll('[data-swdd]').forEach(function (dd) {
        var btn = dd.querySelector('.refpm__swdd-btn');
        var list = dd.querySelector('.refpm__swdd-list');
        var input = dd.querySelector('[data-offer-variant]');
        var dot = dd.querySelector('[data-swdd-dot]');
        var label = dd.querySelector('[data-swdd-label]');
        if (!btn || !list || !input) return;

        function close() { list.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
        function toggle() {
          var open = list.hasAttribute('hidden');
          sec.querySelectorAll('.refpm__swdd-list').forEach(function (l) { l.setAttribute('hidden', ''); });
          sec.querySelectorAll('.refpm__swdd-btn').forEach(function (bt) { bt.setAttribute('aria-expanded', 'false'); });
          if (open) { list.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
        }
        btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
          if (e.key === 'Escape') close();
        });
        list.addEventListener('click', function (e) {
          var opt = e.target.closest('[data-swdd-option]');
          if (!opt) return;
          input.value = opt.getAttribute('data-value');
          if (label) label.textContent = opt.textContent.trim();
          if (dot) {
            var th = opt.getAttribute('data-thumb');
            if (dot.tagName === 'IMG') {
              if (th) { dot.setAttribute('src', th); }
            } else {
              dot.style.setProperty('--c', opt.getAttribute('data-color'));
              dot.style.setProperty('--b', opt.getAttribute('data-border'));
            }
          }
          list.querySelectorAll('[data-swdd-option]').forEach(function (o) {
            o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
          });
          close();
          // la pastille de variante du haut de fiche suit le choix du premier exemplaire
          if (input.getAttribute('data-unit') === '1') {
            var swatch = sec.querySelector('.refpm__swatch-input[value="' + (label ? label.textContent.trim() : '') + '"]');
            if (swatch) { swatch.checked = true; swatch.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        });
        document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
      });

      // amene la galerie sur le visuel de la variante choisie
      function gotoVariantMedia(v) {
        if (!v || !list || !slides.length) return;
        var i = (typeof v.media === 'number') ? v.media : -1;
        if (i < 0 || !slides[i]) return;
        list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (x, j) { x.classList.toggle('is-selected', j === i); });
      }

      // variantes : repercute le choix sur le champ cache du formulaire
      var variantInput = sec.querySelector('[data-variant-input]');
      sec.querySelectorAll('.refpm__swatch-input').forEach(function (input) {
        input.addEventListener('change', function () {
          var label = sec.querySelector('[data-option-value="' + input.dataset.position + '"]');
          if (label) label.textContent = input.value;
          var chosen = [].slice.call(sec.querySelectorAll('.refpm__swatch-input:checked')).map(function (i) { return i.value; });
          var data = sec.querySelector('[data-variants]');
          if (!data || !variantInput) return;
          var variants = JSON.parse(data.textContent);
          var match = variants.find(function (v) { return chosen.every(function (c, k) { return v.options[k] === c; }); });
          if (match) {
            variantInput.value = match.id;
            gotoVariantMedia(match);
          }
        });
      });

      // barre collante : visible une fois le bouton d'achat principal passe
      var quick = sec.querySelector('[data-quickadd]');
      var buyItem = sec.querySelector('.refpm__item--buy');
      if (quick && buyItem) {
        var ticking = false;
        var sync = function () {
          ticking = false;
          quick.classList.toggle('is-visible', buyItem.getBoundingClientRect().bottom < 0);
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(sync);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        sync();
      }

      // minuterie
      sec.querySelectorAll('ref-countdown').forEach(function (el) {
        var out = el.querySelector('[data-countdown]');
        var until = el.getAttribute('data-until');
        function tick() {
          var end;
          if (until && /^\d+$/.test(until)) { end = parseInt(until, 10); }
          else { end = new Date(); end.setHours(24, 0, 0, 0); end = end.getTime(); }
          var d = Math.max(0, end - Date.now());
          var h = Math.floor(d / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
          out.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
        }
        tick();
        setInterval(tick, 1000);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-reviews-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-reviews-slider]').forEach(function (sl) {
      var track = sl.querySelector('[data-track]');
      var slides = track ? [].slice.call(track.children) : [];
      if (!track || !slides.length) return;
      var index = 0;
      function perView() {
        var vp = sl.querySelector('.ml-reviews__viewport');
        if (!vp || !slides[0]) return 1;
        return Math.max(1, Math.round(vp.clientWidth / slides[0].getBoundingClientRect().width));
      }
      function go(n) {
        var max = Math.max(0, slides.length - perView());
        index = Math.min(Math.max(n, 0), max);
        track.style.transform = 'translateX(' + (-index * (100 / perView())) + '%)';
      }
      var prev = sl.querySelector('.ml-reviews__arrow--prev');
      var next = sl.querySelector('.ml-reviews__arrow--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      window.addEventListener('resize', function () { go(index); }, { passive: true });
      go(0);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-tabs"] && !Shopify.designMode) return;
  try {
    
class RefTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.root = this.closest('.reftabs');
    this.buttons.forEach((b, i) => b.addEventListener('click', () => this.select(i)));
  }
  select(index) {
    this.buttons.forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    this.panels.forEach((p, i) => { if (i === index) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } });
    if (this.root) this.root.style.setProperty('--tb-selected', index);
  }
}
if (!customElements.get('ref-tabs')) customElements.define('ref-tabs', RefTabs);

  } catch(e) { console.error(e); }
})();
})();
